import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.observer = new MutationObserver(this.enforceLimit.bind(this));
        this.observer.observe(this.element, { childList: true });

        this.enforceLimit();
    }

    disconnect() {
        this.observer.disconnect();
    }

    /**
     * This is the single, robust function that enforces the display limit.
     * It is called automatically whenever a toast is added OR removed.
     */
    enforceLimit() {
        const limit = this.getLimit();
        const allToasts = Array.from(this.element.children);

        allToasts.forEach((toast, index) => {
            if (index < limit) {
                toast.classList.remove('hidden');
            } else {
                toast.classList.add('hidden');
            }
        });
    }

    /**
     * This action is called by a child `toast_controller` when it is removed.
     * We don't need custom logic here, because the MutationObserver
     * will detect the removal and call enforceLimit() for us.
     */
    toastRemoved() {
        this.enforceLimit();
    }

    getLimit() {
        // Tailwind's `sm` breakpoint is 640px.
        return window.innerWidth < 640 ? 2 : 3;
    }
}